module.exports = __webpack_public_path__ + "img/1572161868.386eaff2.jpg";